'use client';

import { GoogleAnalytics } from '@next/third-parties/google';
import Script from 'next/script';
import { useEffect, useState } from 'react';

import { isCookieConsentAccepted } from '../lib/utils';

export function CookieConsentWrapper({ gaId }: { gaId: string }) {
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    setConsent(isCookieConsentAccepted());
  }, []);

  return (
    <>
      {consent && <GoogleAnalytics gaId={gaId} />}
      <Script
        strategy='afterInteractive'
        src='https://cloud.umami.is/script.js'
        data-website-id='04b9b933-39c6-4ed0-8988-f86d7f0d31a5'
      />
    </>
  );
}
